/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'

const useFetch = (
  fn = () => {},
  params,
  observable = [],
  condition = true,
  oneTime = false,
) => {
  const [response, setResponse] = useState(null)
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingStart, setIsLoadingStart] = useState(true)

  // Evita erros nos quais o componente é desmontado antes da requisição ser concluída e o estado é atualizado
  const isMounted = useRef(true)
  const controllerRef = useRef(null)

  const request = () => {
    if (controllerRef.current) controllerRef.current.abort()
    controllerRef.current = new AbortController()
    const signal = controllerRef.current.signal

    setIsLoading(true)
    setIsLoadingStart(true)

    const isPlainParams =
      params !== null && typeof params === 'object' && !Array.isArray(params)

    fn(isPlainParams ? { ...params, signal } : params, { signal })
      .then((data) => {
        if (isMounted.current) {
          setResponse(data)
        }
      })
      .catch((error) => {
        if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED')
          return
        if (isMounted.current) {
          setError(error)
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setIsLoading(false)
          setIsLoadingStart(false)
        }
      })
  }

  useEffect(() => {
    isMounted.current = true

    if (condition && (!oneTime || !response)) request()

    return () => {
      isMounted.current = false
      if (controllerRef.current) controllerRef.current.abort()
    }
  }, [condition, ...observable])

  return { response, error, isLoading, isLoadingStart, refresh: request }
}

export default useFetch
